import { createFileRoute } from "@tanstack/react-router";

import { Navigate } from "@/lib/router-compat";
export const Route = createFileRoute("/san-jose-dinners")({
  component: () => <Navigate to="/cities/san-jose" replace />,
});
